export default class Folder {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || null;
    this.parent_id = data.parent_id || null;
    this.updated_at = data.updated_at || null;
    this.user_id = data.user_id || null;
    this.recycle_bin = data.recycle_bin || false;
  }
  empty() {
    this.id = null;
    this.name = null;
    this.parent_id = null;
    this.updated_at = null;
    this.user_id = null;
    this.recycle_bin = false;
  }
  isEmpty() {
    return !this.id && !this.name;
  }
  isFilled() {
    return this.id && this.name;
  }
  rename(newName) {
    this.name = newName;
  }
}
